import React, { Fragment, useCallback, useContext, useState } from 'react'
import ProductCard from './ProductCard'
import { Button } from 'primereact/button';
import { AppContext } from '../../../Layout/Layout';
import ProductViewDialog from './ProductCommonUIs/ProductViewDialog';


const GridView = ({ ProductLists, selectedTab }) => {

  const { OpenSearchInputText, OpenSearchProductsDetails, ProductRelatedStates, Actions, ProductRelatedDispatch,
    taxDetails: { InventoryStatus } } = useContext(AppContext);
  const [loadmoreLoading, setLoadMoreLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDialogVisible, setDialogVisible] = useState(false);
  const [count, setCount] = useState(1);

  const handleProductClick = useCallback(
    (product) => {
      setSelectedProduct(product);
      setDialogVisible(true);
    },
    // eslint-disable-next-line
    [selectedProduct, setSelectedProduct, isDialogVisible],
  )


  const handleLoad = async (e) => {
    setLoadMoreLoading(true);
    await OpenSearchProductsDetails({
      SearchText: OpenSearchInputText === "" ? "ListByProduct" : OpenSearchInputText,
      StartFrom: ProductRelatedStates.CatalogProductList.TotalProductCount, ProductRelatedDispatch, Actions,
      ProductCountSize:ProductRelatedStates.ProductCountSize
    });
    setLoadMoreLoading(false);
  }

  const footer = ProductRelatedStates.CatalogProductList.NextToken &&
    <div className='flex justify-content-center align-items-center'>
      <Button type="text" style={{ color: "var(--sidebar-color)" }} rounded outlined
        className='px-4 py-2 text-sm' loading={loadmoreLoading} label="Show More Products"
        onClick={(e) => handleLoad(e)} />
    </div>;

  const updateChoosingUOM = (ChangeUOMDetails) => {
    // console.log("ChangeUOMDetails", ChangeUOMDetails)
    setSelectedProduct({
      ...selectedProduct,
      ChangeUOMDetails: {
        UOM: ChangeUOMDetails.UOM || ChangeUOMDetails.CorrespondingQuantityTypeCode,
        UOMQty: ChangeUOMDetails.id === 0 ? 1 : ChangeUOMDetails.Quantity
      }
    })
    setCount(1);
    // setProductCardState({ type: "ReduceQty", payload: 1 })
  }

  const handleCloseDialog = async () => {
    setSelectedProduct(null);
    setDialogVisible(false);
    setCount(1);
  }
  return (
    <>
      {selectedProduct &&
        <>
          <ProductViewDialog selectedProduct={selectedProduct} setDialogVisible={setDialogVisible} isDialogVisible={isDialogVisible}
            count={count} setCount={setCount} updateChoosingUOM={updateChoosingUOM} InventoryStatus={InventoryStatus}
            ProductRelatedStates={ProductRelatedStates} handleCloseDialog={handleCloseDialog} />
        </>
      }


      <div className='w-100 p-1' style={{ display: "flex", gap: "10px", flexWrap: "wrap" }} >
        {ProductLists.map((Product) => {
          return (
            <Fragment key={Product.id}>
              <ProductCard Product={Product} handleProductClick={handleProductClick} CatagoryHeader
                CardStyle={{ width: "16%", height: "48vh", maxHeight: "50vh", overflow: "hidden" }} />
            </Fragment>
          )
        })}
      </div>
      <div> {selectedTab === 0 && footer} </div>
    </>

  )
}

export default GridView